<template>
  <div class="document-type-search">
    <b-form-input
      :value="value"
      @input="$emit('input', $event)"
      placeholder="🔍 Buscar tipo de documento..."
      class="search-input"
    />
    <div v-if="value" class="search-results-info">
      Mostrando {{ filteredCount }} de {{ totalTypes }} tipos
    </div>
  </div>
</template>

<script>
export default {
  name: 'DocumentTypeSearch',
  props: {
    value: {
      type: String,
      default: ''
    },
    totalTypes: {
      type: Number,
      required: true
    },
    filteredCount: {
      type: Number,
      required: true
    }
  }
};
</script>

<style lang="scss" scoped>
.document-type-search {
  margin-bottom: 1.5rem;
  
  .search-input {
    font-size: 1rem;
    padding: 0.75rem 1rem;
    border-radius: 8px;
    border: 2px solid #e0e0e0;
    transition: border-color 0.3s ease;
    
    &:focus {
      border-color: #7367f0;
      box-shadow: 0 0 0 0.2rem rgba(115, 103, 240, 0.25);
    }
  }
  
  .search-results-info {
    margin-top: 0.5rem;
    font-size: 0.875rem;
    color: #6c757d;
    text-align: center;
  }
}
</style>
